export class WhereClauseUtil {
  static joinWhere(whereArray: string[]): string {
    if (!whereArray || !whereArray.length) {
      return '';
    }
    return whereArray
      .filter(x => x)
      .map(x => this.surroundWithBrackets(x))
      .join(' AND ');
  }

  static getInOrNullClause(fieldName: string, values: any[], nullValue = null): string {
    // transforms '[fieldName] IN(v1, v2, nullValue)' to '[fieldName] IS NULL OR [fieldName] IN(v1, v2)'
    const inValues = values.filter(o => o !== nullValue);
    const preCondition = values.includes(nullValue) ? `${fieldName} IS NULL` : ``;
    const postCondition = inValues.length > 0 ? `${fieldName} IN (${WhereClauseUtil.getWhereValueList(inValues)})` : ``;
    const orClause = preCondition.length > 0 && postCondition.length > 0 ? ` OR ` : ``;
    return `${preCondition}${orClause}${postCondition}`;
  }

  static getWhereValueList(valueList: any[], noMatchValue = null): string {
    let list = '';

    if (valueList.length === 0) {
      if (noMatchValue) {
        list += this.getWhereValue(noMatchValue);
      } else {
        console.log(`Error! Empty IN () clause will be sent to server...`);
      }
    }

    for (let i = 0; i < valueList.length; i++) {
      if (i > 0) {
        list += ',';
      }
      list += this.getWhereValue(valueList[i]);
    }
    return list;
  }

  static getWhereValue(value): string {
    return typeof value === `string` ? `'${value}'` : value;
  }

  private static surroundWithBrackets(where: string) {
    if (!where) {
      return where;
    }

    return `(${where.trim()})`;
  }
}
